<template>
  <div>
    <DriverAccessibilityModal />
    <UserAccessibilityModal />
    <TripAccessibilityModal />

    <layout-vertical>
      <router-view />

      <template #navbar="{ toggleVerticalMenuActive }">
        <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
    </layout-vertical>
  </div>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'
import useAccessibilityShortCuts from '@/utils/accessibility-shortcuts'
import DriverAccessibilityModal from '@/UI/accessibility-modals/DriverAccessibilityModal.vue'
import UserAccessibilityModal from '@/UI/accessibility-modals/UserAccessibilityModal.vue'
import TripAccessibilityModal from '@/UI/accessibility-modals/TripAccessibilityModal.vue'

export default {
  components: {
    DriverAccessibilityModal,
    UserAccessibilityModal,
    TripAccessibilityModal,
    // AppCustomizer,
    LayoutVertical,
    Navbar,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },

  setup(_, ctx) {
    useAccessibilityShortCuts(ctx)
  },
}
</script>
